export const isResidential = customerType => customerType && customerType.trim().toUpperCase() === 'RESIDENTIAL';

export const isComercial = customerType => customerType && customerType.trim().toUpperCase() === 'COMMERCIAL';

export const isSingleFamily = billTypeCode => billTypeCode && billTypeCode.trim().toUpperCase() === 'S';

export const isFiberOrCommercial = (signalAccessCode, customerType) => {
    return (signalAccessCode === 'F' || signalAccessCode === 'X' || isComercial(customerType));
}




// WEBPACK FOOTER //
// ./src/utils/accountUtils.js